import React from 'react';
import { useFieldController } from '../../../../../../helpers/formManager';
import { fieldNames } from '../../constants';
import Field from '../../../../shared/ui/Field';
import { MAX_NAME_SIZE } from '../../../../shared/configs/attachments';
import { useAttachmentDependentFieldConfig } from '../../controllers/useAttachmentsDependentFildConfig';
import TextFieldsExtra from '../TextFieldsExtra';

const name = fieldNames.name;

const NameField = () => {
  const { rules, disabled } = useAttachmentDependentFieldConfig({
    name,
    maxSize: MAX_NAME_SIZE,
  });

  const {
    field,
    fieldState: { error },
  } = useFieldController({
    name,
    defaultValue: '',
    rules,
  });

  return (
    <Field.Memoized
      type={Field.types.input}
      value={field.value}
      onChange={field.onChange}
      disabled={disabled}
      formItemLabel="Наименование"
      required={!disabled}
      formItemValidateStatus={error?.message ? 'error' : undefined}
      formItemExtra={
        <TextFieldsExtra
          errorMessage={error?.message}
          maxSize={MAX_NAME_SIZE}
          valueSize={field.value?.length ?? 0}
        />
      }
    />
  );
};

export default NameField;
